import { t } from "@web-monorepo/i18n/macro";
import { displayClose } from "src/pods/realtime";
import { sendTime } from "src/pods/timer";
import { useToolkitTimerStore } from "src/pods/timer/toolkitTimerStore";
import PresentationPage from "src/shared/components/PresentationPage";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";
import TimerDisplay from "./TimerDisplay";

export default function TimerDisplayContainer() {
  const time = useToolkitTimerStore();

  return (
    <PresentationPage
      variant="timer"
      onRequestHide={() => dispatchToolkitReduxAction(displayClose())}
      closeButtonAriaLabel={t`Close timer display`}
    >
      <TimerDisplay
        sendTime={(nextTime) => dispatchToolkitReduxAction(sendTime(nextTime))}
        time={time}
        fullscreen={true}
        shouldRingBell={true}
      />
    </PresentationPage>
  );
}
